import React from "react";
import {Line} from "react-chartjs-2";

export default function LineChart({ chartData, aspectRatio }) {
  return (
    <>
      <Line
        data={chartData}
        options={{
          layout: {
            padding: 10
          },
          responsive: true,
          aspectRatio: aspectRatio ?? 2,
          plugins: {
            legend: {
              display: true
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (context.dataset.data) {
                    label += ` ${new Intl.NumberFormat('sr-RS', {
                      style: 'currency',
                      currency: 'RSD'
                    }).format(context.dataset.data[context.dataIndex] ?? 0)}`;
                  }
                  return label;
                }
              }
            }
          }
        }}
      />
    </>
  );
}
